<template>
  <TabsTrigger
    v-bind="forwarded"
    class="hover:data-[state=inactive]:bg-primary-700/40 data-[disabled]:text-neutral-700 active:bg-neutral-300/[0.08] data-[state=active]:bg-neutral-300/[0.08] text-neutral-500 hover:text-neutral-300 active:*:text-neutral-300 font-semibold text-base rounded-md"
  >
    <slot />
  </TabsTrigger>
</template>

<script setup>
import { TabsTrigger, useForwardProps } from 'radix-vue';

const props = defineProps({
  as: {
    type: String,
    required: false,
    default: 'button',
  },
  asChild: {
    type: Boolean,
    required: false,
    default: false,
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
  value: {
    type: String,
    required: true,
  },
});

const forwarded = useForwardProps(props);
</script>

<style scoped lang="scss">
[data-state='active'] :deep(a) {
  @apply text-accent-400;
}
</style>
